const getDefaultState = () => {
  return {
    questions: [],
    question: null,
  };
};

const state = getDefaultState();

const getters = {
  questions (state) {
    return state.questions;
  },
  selectedQuestion (state) {
    return state.question;
  }
};

const mutations = {
  setQuestion (state, payload) {
    state.question = payload;
  },
  setQuestions (state, payload) {
    state.questions = payload;
  },
  addQuestion (state, payload) {
    state.questions.unshift(payload);
  },  
  editQuestion (state, payload) {
    Object.assign(state.questions[payload.index], payload.question);
  },
  resetQuestions (state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  callGetQuestions (context, payload) {
    context.commit('getQuestions', payload);
  },
  callSetQuestions (context, payload) {
    context.commit('setQuestions', payload);
  },
  callSelectedQuestion (context, payload) {
    context.commit('setQuestion', payload);
  },
  callAddQuestion (context, payload) {
    context.commit('addQuestion', payload);
  },
  callEditQuestion (context, payload) {
    context.commit('editQuestion', payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/questions.js